<template>
    <div>
        <setting-table ref="table" :url="indexUrl"></setting-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import SettingTable from '../../components/setting/table';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      SettingTable,
      DialogFormWrapper
    },

    props: {
      indexUrl: null,
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },
    },

    created() {
      eventBus.$on('refresh-setting-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-setting-table', this.refresh);
    }
  }
</script>
